// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: 24,
    paginationTypeAdvanced: false,
    filterTreeMobileStyle: 'style1',
    keepScrollState: false,
    enableKeepScrollbackPosition: false
  }
};

// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  'productGridItemHtml': '<figure class="product-tile product-tile--standard" data-product-item data-matchbox-item="{{matchboxItem}}">' +
    '{{itemBadge}}' +
    '<div class="product-tile__media packaging_type__{{packagingType}}">' +
      '<a href="{{itemUrl}}" class="product-tile__link product-tile__link--media">' +
        '{{itemImages}}' +
      '</a>' +
    '</div>' +
    '<div class="product-tile__info">' +
      '<figcaption class="product-tile__info-header">' +
        '<a href="{{itemUrl}}" class="product-tile__link"><h2 class="product-tile__title">{{itemTitle}}</h2></a>' +
        '<p class="product-tile__subtitle">{{itemSubtitle}}</p>' +
        '<p class="product-tile__price">{{itemPrice}}</p>' +
      '</figcaption>' +
      '<div class="product-tile__info-buttons">' +
        '{{itemButtons}}' +
        '{{ProductListingSnippet}}' +
      '</div>' +
    '</div>' +
  '</figure>',

  // Sorting Template
  'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
};

(function() {
  var firstVariant = {};
  var metafields = {
    'product_short_name': '',
    'product_subtitle': '',
    'background_image': '',
    'matchbox_item': ''
  };

  BoostPFS.inject(this);

  function prepareShopifyData(data) {
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    if (data.hasOwnProperty('metafields') && data.metafields.length > 0) {
      var namespace = 'accentuate';
      metafields.product_short_name = Utils.getProductMetafield(data, namespace, 'product_short_name');
      metafields.product_subtitle = Utils.getProductMetafield(data, namespace, 'product_subtitle');
      metafields.ProductListingSnippet = Utils.getProductMetafield(data, 'okendo', 'ProductListingSnippet');
      metafields.background_image = JSON.parse(Utils.getProductMetafield(data, namespace, 'background_image'));
      metafields.packaging_type = Utils.getProductMetafield(data, namespace, 'packaging_type');
      metafields.matchbox_item = firstVariant.id;
    }
    else {
      var no_result_metafields = JSON.parse(document.getElementById('boost-pfs-instant-search-metafields-not-found-json').textContent);

      if( no_result_metafields.hasOwnProperty(data.id) ){
        metafields = {
          'product_short_name': no_result_metafields[data.id].product_short_name,
          'product_subtitle': no_result_metafields[data.id].product_subtitle,
          'background_image': no_result_metafields[data.id].background_image
        };
      }
    }

    return data;
  }

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    data = prepareShopifyData(data);
    //console.log(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Badge
    itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildBadge(data));
    // Add buttons
    itemHtml = itemHtml.replace(/{{itemButtons}}/g, buildButtons(data));
    // Add reviews
    itemHtml = itemHtml.replace(/{{ProductListingSnippet}}/g, metafields.hasOwnProperty('ProductListingSnippet') && metafields.ProductListingSnippet ? '<div data-oke-reviews-product-listing-rating>'+ metafields.ProductListingSnippet.replace(/span/g, 'div') +'</div>' : '');
    // Add Price
    let productPrice = firstVariant.price
    if (data.tags.indexOf(window.productDiscountException) < 0) {
      productPrice = productPrice * window.customerDiscount;
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, Utils.formatMoney(productPrice));
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, metafields.product_short_name || data.title );
    itemHtml = itemHtml.replace(/{{matchboxItem}}/g, metafields.matchbox_item || data.id );
    itemHtml = itemHtml.replace(/{{itemSubtitle}}/g, jQuery('<div/>').html(metafields.product_subtitle).text());
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    // Add Package Type Class
    itemHtml = itemHtml.replace(/{{packagingType}}/g, (metafields.packaging_type || 'standard').replace(/\W+/g, '-').toLowerCase());

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '';
    var bg_image = metafields.hasOwnProperty('background_image') ? metafields.background_image : false;
    var images = data.images_info;
    if (!images || images.length == 0){
      images.push({
          src: boostPFSAppConfig.general.no_image_url,
          width: 340,
          height: 340
      });
    }

    var featured_image_src = Utils.optimizeImage(data.images_info[0].src, '340x340');

    if (bg_image) {
      if (bg_image[0].mime_type.includes('gif')) {
        html += '<img src="'+ bg_image[0].original_src +'" class="product-tile__bg" aria-hidden="true" alt="' + data.title + '" />';
      }
      else if (bg_image[0].media_type == 'video') {
        html += `
          <video aria-hidden="true" class="product-tile__bg" width="${bg_image[0].width}" height="${bg_image[0].height}" autoplay muted loop>
            <source src="${bg_image[0].src}" type="video/mp4">
          </video>
        `;
      }
      else {
        html += '<img src="'+ bg_image[0].cloudinary_src + 'w_680' +'" class="product-tile__bg" aria-hidden="true" alt="' + data.title + '" />';
      }
    }

    html += '<img src="'+ featured_image_src +'" class="product-tile__image" alt="' + data.title + '" />';
    return html;
  }

  function buildButtons(data) {
    var html = '';

    if (data.variants.length == 1) {
      html += '<button type="button" class="product-tile__button" data-product-item-variant="{{itemId}}"';

      if( !data.available ){
        html += ' disabled>' + boostPFSConfig.label.sold_out;
      }
      else {
        html += '>' + boostPFSConfig.label.add_to_cart + '<span class="product-tile__button-extra">&nbsp;&dash;&nbsp;{{itemPrice}}</span>';
      }

      html += '</button>';
    }
    else {
      html += '<a href="{{itemUrl}}" class="product-tile__button">Shop Now</a>';
    }

    return html;
  }

  function buildBadge(data) {
    var badgeLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("Badge:") !== -1) {
          badgeLabel += tag.split('Badge:')[1];
          break;
        }
      }
    }

    if (badgeLabel != '') {
      return '<div class="product-badge">' +
        '<span class="product-badge__text">'+ badgeLabel +'</span>' +
      '</div>';
    }
    else {
      return '';
    }
  }


  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
        var sortingArr = Utils.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            return html;
        }
    }
    return '';
  };

  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  var $ad_template = $('#collection-ad-template');

  function buildTileAd() {
    // Product Tile Ad
    if( $ad_template.length && $('.product-tile-ad').length == 0 ){
      var $ad_el = $($ad_template.html());
      var ad_pos = parseInt( $ad_template.attr('data-position') );
      if (ad_pos < 1) {
        ad_pos = 1;
      }
      var $after_product = $('.collection .product-tile:nth-child('+ (ad_pos) +')');

      if( $after_product.length ){
        $after_product.before( $ad_el );
      }
    }
  }

  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    buildTileAd();
    new ProductTile()
  };

  window.addEventListener('DOMContentLoaded', (e) => {
    buildTileAd();
  });

  // Build additional elements
  Filter.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    if( jQ('body').hasClass('template-search') ) {
      var show_results_label = 'Search results: '+ data.total_product +' for "'+ jQ('#boost-pfs-search-box-1').val() +'"';
      var no_results_label = 'Your search for "'+ jQ('#boost-pfs-search-box-1').val() +'" didn\'t return any results.';

      if( data.total_product > 0 ){
        jQ('.search-page__title').text( show_results_label );
      }
      else {
        jQ('.product-list-no-search-result-text').remove();
        jQ('.search-page__title').text( no_results_label );
      }
    }
    else {

      // filter slide out
      var section = jQ('section.collection');
      var filterToggle = jQ('[data-filter-drawer-toggle]');

      filterToggle.off('click').on('click', function(e) {
        e.preventDefault();
        section.toggleClass('collection--filter-closed');
      });

      // clear all button
      jQ('.collection__clear-all').html('');
      jQ('.collection__clear-all').append(this.filterTrees[0].clearAllButton.$element);

      // results count
      var totalProduct = data.total_product + '&nbsp;' + boostPFSThemeConfig.label.items_with_count_other;
      if (data.total_product == 1) {
        totalProduct = data.total_product + '&nbsp;' + boostPFSThemeConfig.label.items_with_count_one;
      }
      jQ('.collection__count').html(totalProduct);

      // filter tags - header
      var applied_filters = '';
      var filter_count = 0;
      jQ('.collection__current-filters ul').html('');
      this.filterTrees[0].filterOptions.forEach(function(filterOption) {
        // FilterOption has numberAppliedFilterItems field. We add those up.
        filter_count += filterOption.numberAppliedFilterItems;

        filterOption.filterItems.forEach(function(item) {
          if (item.isSelected){
            var $filter_item = jQ('<li>'+ item.label +'</li>');
            applied_filters += $filter_item;
            jQ('.collection__current-filters ul').append( $filter_item );
            $filter_item.click(function(){
              var text = jQ(this).text();
              jQ('.boost-pfs-filter-option-item.selected').each(function(){
                if ( jQ(this).find('.boost-pfs-filter-option-value').text() == text ) {
                  jQ(this).find('button').click();
                }
              });
            });
          }
        });
      });

      if (filter_count > 0 ){
        jQ('.boost-pfs-filter-show-result').show();
        jQ('.collection__filter-count').text('(' + filter_count + ')');
        jQ('.boost-pfs-filter-mobile-count').text(' (' + filter_count + ')');
      }
      else {
        jQ('.boost-pfs-filter-show-result').hide();
        jQ('.collection__filter-count').text('');
        jQ('.boost-pfs-filter-mobile-count').text('');
      }
    }
  };

  // Mobile Filter
  FilterTree.prototype.getTemplate = function(){
    var html = '<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">' +
      '{{header}}' +
      '<div class="boost-pfs-sort-mobile">' +
        '<div class="boost-pfs-filter-option boost-pfs-filter-option-list boost-pfs-filter-no-scrollbar boost-pfs-filter-option-column-1">' +
          '<div class="boost-pfs-filter-option-title">' +
            '<button aria-label="Sort By" aria-controls="mobile-sort" tabindex="0" class="boost-pfs-filter-button boost-pfs-filter-option-title-heading" aria-expanded="true">' +
              '<span class="boost-pfs-filter-option-title-text">Sort By</span>' +
            '</button>' +
          '</div>' +
          '<div class="boost-pfs-filter-option-content" id="mobile-sort">' +
            '<ul class="boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-multiple-list">' +
              '{{sortingItems}}' +
            '</ul>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="{{class.filterOptionsWrapper}}">' +
        '{{filterOptions}}' +
      '</div>' +
      '{{footer}}' +
    '</div>';

    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      var paramSort = Globals.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if (paramSort == k) {
          activeClass = 'selected';
        }
        sortingItemsHtml += '<li class="boost-pfs-filter-option-item boost-pfs-filter-option-label '+ activeClass +'">';
        sortingItemsHtml += '<button role="checkbox" class="boost-pfs-filter-button" data-sort="' + k + '">';
        sortingItemsHtml += '<span class="boost-pfs-check-box"></span>';
        sortingItemsHtml += '<span class="boost-pfs-filter-option-value">'+ sortingArr[k] +'</span>';
        sortingItemsHtml += '</button>';
        sortingItemsHtml += '</li>';
      }
      html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }

    return html;
  };

	// Mobile Sorting Events
  jQ('.collection').on('click', '.boost-pfs-sort-mobile button', function (e) {
    FilterApi.setParam('sort', jQ(this).data('sort'));
    FilterApi.setParam('page', 1);
    FilterApi.applyFilter('sort');
    jQ('.boost-pfs-sort-mobile li').removeClass('selected');
    jQ(this).parent().toggleClass('selected');
  });

  // Mobile Clear Button
  jQ('.collection').on('click', '.collection__clear-all button', function (e) {
    FilterApi.applyFilter('clearAll');
  });

  // Mobile Filter Header
  FilterTree.prototype.getHeaderTemplate = function(){
    var html = '';
    var closeButton = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="26px" height="26px" viewBox="0 0 26 26" xml:space="preserve"><g><polygon points="16.016,12.98 25.755,3.153 22.722,0.146 12.985,9.978 3.156,0.243 0.146,3.253 9.986,13.006 0.243,22.844 3.253,25.854 13.013,16.008 22.846,25.756 25.854,22.722 "/></g></svg>'
    html += '<div class="boost-pfs-filter-mobile-header">' +
              '<label class="boost-pfs-filter-mobile-heading">Filter<span class="boost-pfs-filter-mobile-count"></span></label>' +
              '<a href="javascript:;" class="{{class.closeFilterButton}}">'+ closeButton +'</a>' +
            '</div>';

    return html;
  };

  // Mobile Filter Footer
  FilterTree.prototype.getFooterTemplate = function(){
    var html = '';
    html += '<div class="boost-pfs-filter-mobile-footer">' +
              '<div class="collection__clear-all"></div>' +
              '<button class="{{class.showResultFilterButton}}" type="button">Apply<span class="boost-pfs-filter-mobile-count"></span></button>' +
            '</div>';

    return html;
  };

  // Mobile Filter Toggle
  FilterMobileButton.prototype.getTemplate = function (){
    var html = '';
    html += '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12"><g id="Group_807" data-name="Group 807" transform="translate(-557 -921)">' +
      '<rect id="Rectangle_1103" data-name="Rectangle 1103" width="15" height="2" transform="translate(557 923)"/><rect id="Rectangle_1104" data-name="Rectangle 1104" width="15" height="2" transform="translate(557 929)"/>' +
      '<rect id="Rectangle_1105" data-name="Rectangle 1105" width="2" height="6" transform="translate(561 921)"/><rect id="Rectangle_1106" data-name="Rectangle 1106" width="2" height="6" transform="translate(566 927)"/></g></svg>' +
      '<label class="collection__filter-toggle-label">Filter <span class="collection__filter-count"></span></label>';

    return html;
  };

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function(a, b) {}
})();

$('body').on('click', '[aria-controls="mobile-sort"]', function(e) {
  e.preventDefault()

  const $el = $(this)
  const $sort = $('#mobile-sort')

  $sort.slideToggle()
  $el.closest('.boost-pfs-filter-option').toggleClass('boost-pfs-filter-option-collapsed').attr('aria-expanded', !$sort.is(':visible'))
})

// Clear all button
document.addEventListener('click', function(e) {
  if (e.target.matches('.boost-pfs-filter-button.boost-pfs-filter-clear-all')) {
    Array.from(document.querySelectorAll('.boost-pfs-filter-button[aria-checked="true"]')).forEach(function(el) {
      el.click()
    })
  }
})
